import React, { useEffect, useState, useContext } from "react";
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner.js";
import NavbarFixed from "../components/Navbar-Fixed.js";
import SocketContext from "../context/SocketContext";
import { useDispatch, useSelector } from "react-redux";


// import components
import Trade from "../components/Trade";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";




export default function TradePage(props) {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);



  return (
    <div>

      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />


      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden">
          <Trade />
        </div>
      </div>

      {/* <FooterNew/> */}
    </div>
  );
}
